import React from "react";
import { withRouter } from "react-router-dom";
import { Row, Col } from 'antd';
import PropTypes from "prop-types";
import { ContribType, ContributionName, ComponentDivider, ComponentDividerLast } from './styles';
import {  LetterOfAuthorization, AuthorizationText, FontBoldText } from "../../../../../ContributionActivity/Components/ViewContribution/Components/FundingInstructions/styles";
import { connect } from "react-redux";
import formatter from "../../../../../../../../utils/formatter";
import Preloader from "../../../../../../../../CommonComponents/Preloader/Preloader";
import { getPrimaryAccount } from "../../../../../../../../utils/sessionUtil";
import { getTradeCutOffDateAndTime } from '../../../../../../../../services/apiServices';
import { milliToDate } from "../../../../../../../../utils/commonUtil";
import { contributionTypeStep3State } from "../../../../selectors";

export class ContributionType extends React.Component {
    constructor(props) {
        super(props);
        this.state = {tradeCutoffDate : null}
    }

    renderContributionTypes = (contribution, name,count) => {
        let logAddress = contribution.Donors[0].Address;
        let logLine1 = logAddress.line1 ? logAddress.line1 + ", " : "";
        let logLine2 = logAddress.line2 ? logAddress.line2 + ", " : "";
        let logLine3 = logAddress.line3 ? logAddress.line3 + ", " : "";
        let logCity = logAddress.city ? logAddress.city + ", " : "";
        let logAddress1 = logLine1 + logLine2 + logLine3;
        let logAddress2 = logCity +  logAddress.state + ", " + logAddress.zipCode + ", " + logAddress.country ;
        let logDonorName = contribution.Donors[0].name;
        let logAddType = contribution.Donors[0].addressType;
        let address = contribution.type !== "Individual" ? contribution.Donors[1].Address : contribution.Donors[0].Address;
        let line1 = address.line1 ? address.line1 + ", " : "";
        let line2 = address.line2 ? address.line2 + ", " : "";
        let line3 = address.line3 ? address.line3 + ", " : "";
        let city = address.city ? address.city + ", " : "";
        let address1 = line1 + line2 + line3;
        let address2 = city +  address.state + ", " + address.zipCode + ", " + address.country;
        let donorName =  contribution.type !== "Individual" ? (contribution.type === "Joint" ? (contribution.Donors[1].firstName + " " + contribution.Donors[1].lastName) : contribution.Donors[1].name) : contribution.Donors[0].name;
        let addType = contribution.Donors[1].addressType;
        return (
        <div>
          {['Asset held at Vanguard - mutual fund','Asset held at Vanguard - security'].includes(name) ?
      <LetterOfAuthorization width='true'>   
        {name === 'Asset held at Vanguard - mutual fund' ?
        (this.state.tradeCutoffDate && this.state.tradeCutoffDate.tradeCutoffDateAndTime ?
          <div className="mb-20">Please note: Contributions of Vanguard Mutual Funds that are received after the trade cutoff will be processed the following business day. Contributions cannot be processed until the Letter of Authorization is received by Vanguard Charitable. The trade cutoff for <FontBoldText>{milliToDate(this.state.tradeCutoffDate.tradeCutoffDateAndTime)}</FontBoldText> is <FontBoldText>2:00 PM EDT</FontBoldText></div>
          :
          <div className="mb-20">Please note: Contributions of Vanguard Mutual Funds that are received after the trade cutoff will be processed the following business day. Contributions cannot be processed until the Letter of Authorization is received by Vanguard Charitable. { this.state.tradeCutoffDate && this.state.tradeCutoffDate.message}</div>
        )
        : ''
        }
        {this.props.isConfirmation ?
        (name === 'Asset held at Vanguard - security' ? <div className="mt-20 mb-20"><AuthorizationText>A signed Letter of Authorization(provided on the Funding Instructions page) will be required for the completion of this contribution.</AuthorizationText></div> : '')
        :
        <div className="mt-20 mb-20"><AuthorizationText>A signed Letter of Authorization(provided on the next page) will be required for the completion of this contribution unless you already have a Standard Letter of Authorization on file at Vanguard Charitable for this Vanguard or VBS account. More information about the difference between Letters of Authorization and Standing Letters of Authorization will be provided on the next page.</AuthorizationText></div>
        }
      </LetterOfAuthorization>  
      : '' }
          <Row>
          <Col lg={{ span: 12 }} md={{ span: 12 }}>
            <Row>
              <Col >
                <ContribType>Type:</ContribType>
                <ContributionName >{name}</ContributionName>
              </Col>
            </Row>
            <ComponentDivider bottom="20px" mobileBottom="10px" />
          </Col>
        </Row>
      
        <Row>
          <Col lg={{ span: 12 }} md={{ span: 12 }}>
            <Row>
              <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                <ContribType>Source of Donation:</ContribType>
                <ContributionName>
                  {contribution.type}
                </ContributionName>
              </Col>
              {(name === "Check or electronic bank transfer" || name === "Wire") ? 
              <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                <ContribType>Dollar Amount:</ContribType>
                <ContributionName >
                   {formatter({
                    value: contribution.amount,
                    fieldSuffix: "Dollars"
                  })}
                </ContributionName>
              </Col>
              :  
              ((name === 'Asset held at Vanguard - mutual fund') ? 
              <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                <ContribType>Vanguard Account Number:</ContribType>
                <ContributionName >
                   {contribution.VGAccountNumber}
                </ContributionName>
              </Col> 
              : 
              ((name === 'Asset held at Vanguard - security') ? 
              <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                <ContribType>VBS Account Number:</ContribType>
                <ContributionName >
                  {contribution.VGAccountNumber}
                </ContributionName>
              </Col> : ''
              ))
              }
            </Row>
            <ComponentDivider bottom="20px" mobileBottom="10px" />
          </Col>
        </Row>
        {
          (name === 'Asset held outside Vanguard - mutual fund' || name === 'Asset held outside Vanguard - security') ?
          <Row>
          <Col lg={{ span: 12 }} md={{ span: 12 }}>
            <Row>
              <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                <ContribType>Account Number:</ContribType>
                <ContributionName>
                  {contribution.accountNumber}
                </ContributionName>
              </Col>
              <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                <ContribType>{name === 'Asset held outside Vanguard - mutual fund' ? 'Holding Firm:' : 'Brokerage Firm:'}</ContribType>
                <ContributionName >
                  {contribution.holdingFirm}
                </ContributionName>
              </Col>
            </Row>
            <ComponentDivider bottom="20px" mobileBottom="10px" />
          </Col>
        </Row>
        : ''
        }
        {
          (name === 'Asset held at Vanguard - mutual fund' || name === 'Asset held outside Vanguard - mutual fund' || name === 'Asset held at Vanguard - security' || name === 'Asset held outside Vanguard - security' || name === 'Stock certificate') ?
          contribution.fundInformation.map(fund => (
            <>
            <Row>
              <Col lg={{ span: 12 }} md={{ span: 12 }}>
                <Row>
                  <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                    <ContribType>{(name === 'Asset held at Vanguard - mutual fund' || name === 'Asset held outside Vanguard - mutual fund') ? 'Fund Name:' :  'Security Name:'}</ContribType>
                    <ContributionName>
                      {(name === 'Asset held at Vanguard - mutual fund' || name === 'Asset held outside Vanguard - mutual fund') ? fund.fundName : fund.securityName}
                    </ContributionName>
                  </Col>
                  <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                    <ContribType>{(name === 'Asset held at Vanguard - security' || name === 'Asset held outside Vanguard - security' || name === 'Stock certificate') ? 'Security Ticker:' : 'Fund Ticker:'}</ContribType>
                    <ContributionName >
                      {fund.tickerSymbol}
                    </ContributionName>
                  </Col>
                </Row>
                <ComponentDivider bottom="20px" mobileBottom="10px" />
              </Col>
            </Row>
            <Row>

            <Col lg={{ span: 12 }} md={{ span: 12 }}>
              <Row>
                {(name === 'Asset held at Vanguard - mutual fund' || name === 'Asset held outside Vanguard - mutual fund') ? 
                <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                  <ContribType>Fund Number:</ContribType>
                  <ContributionName>
                    {fund.fundNumber}
                  </ContributionName>
                </Col>
                : ''
                }
                <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                  <ContribType>Number of shares:</ContribType>
                  <ContributionName >
                    {fund.allShare ? 'All Shares' : fund.numberofShares}
                  </ContributionName>
                </Col>
              </Row>
              <ComponentDivider bottom="20px" mobileBottom="10px" />
            </Col>
          </Row>
          </>
          ))
         : ''
        }
        <Row>
          <Col lg={{ span: 12 }} md={{ span: 12 }}>
            <Row>
            <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                <ContribType>Donor:</ContribType>
                <ContributionName >
                  {logDonorName}
                </ContributionName>
              </Col>
              <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                <ContribType>Donor Address:</ContribType>
                <ContributionName>{logAddress1}</ContributionName>
                <ContributionName>{logAddress2}</ContributionName>
              </Col>
            </Row>
            <ComponentDivider bottom="20px" mobileBottom="10px" />
          </Col>
        </Row>
        <Row>
          <Col lg={{ span: 12 }} md={{ span: 12 }}>
            <Row>
            <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                <ContribType>Address Type:</ContribType>
                <ContributionName >
                  {logAddType}
                </ContributionName>
              </Col>
            </Row>
            {contribution.type !== "Individual" ? <ComponentDivider bottom="20px" mobileBottom="10px" /> : ''}
          </Col>
        </Row>
        {contribution.type !== "Individual" ?  
      <>
      <Row>
          <Col lg={{ span: 12 }} md={{ span: 12 }}>
            <Row>
            <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                <ContribType>Donor:</ContribType>
                <ContributionName >
                  {donorName}
                </ContributionName>
              </Col>
              <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                <ContribType>Donor Address:</ContribType>
                <ContributionName>{address1}</ContributionName>
                <ContributionName>{address2}</ContributionName>
              </Col>
            </Row>
            {
              (contribution.type === "Joint")? 
            <ComponentDivider bottom="20px" mobileBottom="10px" />:null
    }
          </Col>
        </Row> 

        {
        (contribution.type === "Joint")?
        <Row>
        <Col lg={{ span: 12 }} md={{ span: 12 }}>
          <Row>
          <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
              <ContribType>Address Type:</ContribType>
              <ContributionName >
                {addType}
              </ContributionName>
            </Col>
          </Row>
        </Col>
      </Row> :null
    }

      </>
        
        : ''
        }
               <ComponentDividerLast />
            </div>
    )};

    getTradeCutoffDate = () => {
      const promises = [];
      promises.push(getTradeCutOffDateAndTime({userId: getPrimaryAccount().userId}));
      Promise.all(promises).then((response) => {
        this.setState({ tradeCutoffDate: response[0].data })
      });
    }

    render() {
        const { contributionTypes } = this.props;
        if(!this.state.tradeCutoffDate){
          this.getTradeCutoffDate();
          return <Preloader />
        }else {
        return (
            <>
            {(contributionTypes.assetHeldatVG.mfSelected === true) ? contributionTypes.assetHeldatVG.mutualFund.map((contribution,index) => this.renderContributionTypes(contribution,'Asset held at Vanguard - mutual fund', index +1)) : null}
            {(contributionTypes.assetHeldatVG.sgSelected === true) ? contributionTypes.assetHeldatVG.securityGift.map((contribution,index) => this.renderContributionTypes(contribution,'Asset held at Vanguard - security', index +1)) : null}
            {(contributionTypes.assetOutsideVG.mfSelected === true) ? contributionTypes.assetOutsideVG.mutualFund.map((contribution,index) => this.renderContributionTypes(contribution,'Asset held outside Vanguard - mutual fund', index +1)) : null}
            {(contributionTypes.assetOutsideVG.sgSelected === true) ? contributionTypes.assetOutsideVG.securityGift.map((contribution,index) => this.renderContributionTypes(contribution,'Asset held outside Vanguard - security', index +1)) : null}
            {(contributionTypes.checkOrEBT.checkSelected === true) ? contributionTypes.checkOrEBT.checkEBTList.map((contribution,index) => this.renderContributionTypes(contribution,'Check or electronic bank transfer', index +1)) : null}
            {(contributionTypes.wire.wireSelected === true) ? contributionTypes.wire.wireList.map((contribution,index) => this.renderContributionTypes(contribution,'Wire', index +1)) : null}
            {(contributionTypes.stockCertificate.stockSelected === true) ? contributionTypes.stockCertificate.stockCertificateList.map((contribution,index) => this.renderContributionTypes(contribution,'Stock certificate', index +1)) : null}
            </>
        );
        }
    }
}

ContributionType.propTypes = {
  contributionTypes: PropTypes.object,
}

const mapStateToProps = state => ({
    ...contributionTypeStep3State(state.toJS())
  });
  
export default withRouter(connect(mapStateToProps, null)(ContributionType));

